import {Component, OnInit} from '@angular/core';
import {UtilitiesService} from "../../helpers/utilities.service";

@Component({
    selector: 'app-supporters',
    templateUrl: './supporters.component.html',
    styleUrls: ['./supporters.component.scss']
})
export class SupportersComponent implements OnInit {

    private URL: string = "";
    supporterFaculties = [];
    supporterMedia = [];
    supporterOther = [];
    

    constructor(private utils: UtilitiesService) {
        this.URL = this.utils.getStaticImageApi();
        this.supporterFaculties = [
            {
                name: 'Универзитет „Св. Кирил и Методиј',
                img: this.URL + '/supporters/ukim-logo.webp',
                link: 'https://www.ukim.edu.mk/'
            },
            {
                name: 'Факултет за Електротехника и Информациски Технологии',
                img: this.URL + '/supporters/feit-logo.webp',
                link: 'https://feit.ukim.edu.mk/'
            },
            {
                name: 'Машински Факултет',
                img: this.URL + '/supporters/masinski-logo.webp',
                link: 'https://www.mf.ukim.edu.mk/'
            },
            {
                name: 'Технолошко Металуршки Факултет',
                img: this.URL + '/supporters/tmf-logo.webp',
                link: 'http://www.tmf.ukim.edu.mk'
            },
            {
                name: 'Центар за кариера - УКИМ',
                img: this.URL + '/supporters/centar-za-kariera-logo.webp',
                link: 'https://www.ukim.edu.mk/'
            },
        ];
        this.supporterMedia = [
            {
                name: 'Канал 5',
                img: this.URL + '/supporters/kanal5-logo.webp',
                link: 'http://kanal5.com.mk/'
            },
            {
                name: 'Сител',
                img: this.URL + '/supporters/sitel-logo.webp',
                link: 'https://sitel.mk/'
            },
            {
                name: 'МРТ',
                img: this.URL + '/supporters/mrt-logo.webp',
                link: 'http://www.mrt.com.mk/'
            },            
            {
                name: 'Црнобело',
                img: this.URL + '/supporters/crnobelo-logo.webp',
                link: 'https://www.crnobelo.com/'
            },
        ];
        this.supporterOther = [
            {
                name: 'Канела Прима',
                img: this.URL + '/supporters/kanela.webp',
                link: 'http://canellaprima.com/'
            },
            {
                name: 'Мелем Од Вкусови',
                img: this.URL + '/supporters/melem.webp',
                link: 'https://www.instagram.com/melem_od_vkusovi/'
            },
            {
                name: 'Champagne Lux Wall',
                img: this.URL + '/supporters/lux.webp',
                link: 'https://www.instagram.com/champagne.lux.wall/'
            },
            {
                name: 'VODAVODA',
                img: this.URL + '/supporters/vodavoda.webp',
                link: 'https://vodavoda.com/'
            },
            {
                name: 'Nestlé',
                img: this.URL + '/supporters/nescafe.webp',
                link: 'https://www.nestle.mk/proizvodi/kafe/nescafe'
            },
        ];
    }

    ngOnInit(): void {
    }

}